export const useFlexBox = () => {
    const flow = {
        vertical: {
            normal: "column nowrap",
            reversed: "column-reverse nowrap",
        },
        horizontal: {
            normal: "row wrap",
            reversed: "row-reverse wrap"
        },
    }
    // alignment gets inverted if the orientation is "reversed"
    const alignment = {
        vertical: {
            "top-left": {
                alignItems: "flex-start",
                justifyContent: "flex-start"
            },
            "top-center": {
                alignItems: "center",
                justifyContent: "flex-start"
            },
            "top-right": {
                alignItems: "flex-end",
                justifyContent: "flex-start"
            },
            "top-opposite": {
                alignItems: "space-between",
                justifyContent: "flex-start"
            },
            "middle-left": {
                alignItems: "flex-start",
                justifyContent: "center"
            },
            "middle-center": {
                alignItems: "center",
                justifyContent: "center"
            },
            "middle-right": {
                alignItems: "flex-end",
                justifyContent: "center"
            },
            "middle-opposite": {
                alignItems: "space-between",
                justifyContent: "center"
            },
            "bottom-left": {
                alignItems: "flex-start",
                justifyContent: "flex-end"
            },
            "bottom-center": {
                alignItems: "center",
                justifyContent: "flex-end"
            },
            "bottom-right": {
                alignItems: "flex-end",
                justifyContent: "flex-end"
            },
            "bottom-opposite": {
                alignItems: "space-between",
                justifyContent: "flex-end"
            },
            fill: {
                alignItems: "stretch",
            }
        },
        horizontal: {
            "top-left": {
                alignItems: "flex-start",
                justifyContent: "flex-start"
            },
            "top-center": {
                alignItems: "flex-start",
                justifyContent: "center"
            },
            "top-right": {
                alignItems: "flex-start",
                justifyContent: "flex-end"
            },
            "top-opposite": {
                alignItems: "flex-start",
                justifyContent: "space-between"
            },
            "middle-left": {
                alignItems: "center",
                justifyContent: "flex-start"
            },
            "middle-center": {
                alignItems: "center",
                justifyContent: "center"
            },
            "middle-right": {
                alignItems: "center",
                justifyContent: "flex-end"
            },
            "middle-opposite": {
                alignItems: "center",
                justifyContent: "space-between"
            },
            "bottom-left": {
                alignItems: "flex-end",
                justifyContent: "flex-start"
            },
            "bottom-center": {
                alignItems: "flex-end",
                justifyContent: "center"
            },
            "bottom-right": {
                alignItems: "flex-end",
                justifyContent: "flex-end"
            },
            "bottom-opposite": {
                alignItems: "flex-start",
                justifyContent: "space-between"
            },
            fill: {
                alignItems: "stretch"
            }
        }
    }

    return { alignment, flow }
}